import styled, { css } from 'styled-components';
import { PALE_WHITE_6, PRIMARY_COLOR_8, WHITE } from '../../appearance/Colors';

// Geometry belongs to the host (docked, mobile overlay or standalone page).
// The presentation and flow inside the preview are shared by every host.
export const previewPanelSurface = css`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 0;
    background-color: ${PRIMARY_COLOR_8};
    color: ${WHITE};
    backdrop-filter: saturate(180%) blur(20px);
`;
export const PreviewScroll = styled.div`
    overflow-y: auto;
    padding-bottom: ${({ $bottomPadding = 76 }) => `${$bottomPadding}px`};
    padding-left: ${({ $padded = true }) => $padded ? '12px' : '0'};
    padding-right: ${({ $padded = true }) => $padded ? '12px' : '0'};
    flex: 1; min-height: 0;
`;
export const PreviewBody = styled.div`
    position: relative;
    display: flex;
    flex-direction: column;
    min-height: 100%;
    box-sizing: border-box;
    padding: ${({ $padded }) => $padded ? '12px' : '0'};
    // overflow-y: auto;
`;
export const PreviewInfoPlacement = styled.div`
    margin-top: auto;
    flex-shrink: 0;
`;
export const PreviewTitleText = styled.div`
    width: 100%;
    min-height: 24px;
    box-sizing: border-box;
    padding: 4px 0;
    font-size: 17px;
    font-weight: 700;
    letter-spacing: -0.2px;
    line-height: 1.35;
    color: ${props => props.$isEmpty ? 'rgba(255,255,255,0.45)' : 'rgba(255,255,255,0.95)'};
    white-space: pre-wrap;
    word-break: break-word;
    cursor: ${({ $readOnly }) => $readOnly ? 'default' : 'pointer'};
`;

export const PreviewHeader = styled.div`
    display: flex;
    flex-direction: row;
    padding-bottom: 4px;
    padding-top: 8px;
    padding-left: 12px;
    padding-right: 12px;
    align-items: center;
    justify-content: space-between;
    color: ${PALE_WHITE_6};
    // background-color: ${PRIMARY_COLOR_8};
    flex-shrink: 0;
`;
